export default function CTABanner() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20pattern%20of%20overlapping%20circles%20in%20coral%20sage%20green%20and%20warm%20beige%20tones%20flowing%20organic%20shapes%20modern%20artistic%20background%20design%20smooth%20gradients%20soft%20contemporary%20feel%20wallpaper%20style%20playful%20yet%20sophisticated&width=1920&height=600&seq=cta-v2-kkb-2026&orientation=landscape"
          alt="Shop Kakobuy Spreadsheet products"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight">
              Ready to Shop?
            </h2>
            <p className="mt-3 text-white/75 text-sm md:text-base max-w-md leading-relaxed">
              Browse thousands of verified products across 14 curated categories. Your next great find is just a click away.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-accent-500 text-white font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
            >
              <span>Buy It Now</span>
              <span className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full border-2 border-white text-white font-semibold text-sm md:text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap text-center justify-center"
            >
              kakobuy spreadsheet
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}